<daas-consulting-shared-layout-empty-state
  class="translate-y-1/2 scale-75"
></daas-consulting-shared-layout-empty-state>

<div class="bg-gray-50">
  <div
    class="mx-auto max-w-2xl px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8 transition-transform duration-150"
    [class.scale-125]="animate$ | async"
    [class.scale-100]="(animate$ | async) === false"
  >
    <div class="flex flex-col items-center text-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
        />
      </svg>
      <h3 class="mt-2 text-sm font-semibold text-gray-900">
        No se econtraron registros
      </h3>
      @if(showAdjustFilters){
      <p class="mt-1 text-sm text-gray-500">
        Comienza por ajustar los filtros para poder encontrar registros.
      </p>
      }
    </div>
  </div>
</div>
